var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 36,
    viewBox: "0 0 31 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.32205 17.7038V10.4231L15.1946 5.96333C17.8217 7.44993 20.443 8.93653 23.0672 10.4231V21.6982H8.94887H1.63392C1.36661 21.1001 1.09356 20.5106 0.872243 19.8984C-0.036018 17.385 -0.234341 14.6827 0.274401 12.0846C0.826255 9.25247 2.22026 6.55289 4.45068 4.36671C7.41977 1.45557 11.3086 0 15.1946 0C19.0863 0 22.9752 1.45557 25.9385 4.36671C28.9047 7.28068 30.3879 11.0973 30.3879 14.9111C30.3879 18.7278 28.9047 22.5473 25.9385 25.4556L15.1946 36L4.45068 25.4584C3.99655 25.0127 3.56541 24.5331 3.17164 24.0339H6.35918L15.1946 32.708L24.2628 23.8082C26.7634 21.354 28.0166 18.1298 28.0166 14.9111C28.0166 11.6925 26.7634 8.47109 24.2628 6.0141C21.7594 3.5543 18.4741 2.32722 15.1946 2.32722C11.9151 2.32722 8.6327 3.55712 6.12924 6.01128C4.24373 7.86178 3.07104 10.1354 2.60541 12.5162C2.15703 14.7955 2.35823 17.1678 3.20038 19.3625H20.693V11.7602C18.8564 10.7193 17.0255 9.68124 15.1946 8.64316L9.69905 11.7602V17.7094H7.32205V17.7038Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.f9bff1a9c877cb072286c690388717cc.svg";
export { ForwardRef as ReactComponent };